// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const scream_tail: PokeData = {
  "id": 985,
  "name": "scream-tail",
  "height": 12,
  "weight": 80,
  "base_experience": 285,
  "types": [
    PokeType.FAIRY,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "pound",
    "body-slam",
    "bite",
    "sing",
    "disable",
    "rest",
    "perish-song",
    "crunch",
    "wish",
    "hyper-voice",
    "howl",
    "gyro-ball",
    "noble-roar",
    "play-rough",
    "boomburst",
    "psychic-fangs"
  ],
  "moves": [
    "body-slam",
    "bite",
    "crunch",
    "hyper-voice",
    "play-rough",
    "psychic-fangs",
    "psy-ball",
    "sweet-kiss",
    "heal-bell",
    "kinesis",
    "guardian-bond",
    "starfall",
    "psychic-terrain"
  ],
  "evolution_chain": {
    "id": 516,
    "item": null,
    "species": [
      {
        "name": "scream-tail",
        "order": 982,
        "types": [
          PokeType.FAIRY,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 155,
    "speed": 155,
    "ability_power": 91
  },
  "stat_changes": [],
  "catch_rate": 50,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
